import { ButtonType } from '@src/types/types';
import { Button } from './Button';

export type TextContainerWithButtonProps = {
  headerText: string;
  contentText: string;
  buttonText: string;
  onButtonTap: () => void;
};

export function TextContainerWithButton({
  headerText,
  contentText,
  buttonText,
  onButtonTap,
}: TextContainerWithButtonProps) {
  return (
    <div className="bg-background rounded-2xl p-6 flex flex-col h-[300px] border border-grey3light w-[400px] flex-shrink-0">
      {/* Header section - fixed height */}
      <div className="h-[32px] mb-4">
        <h2 className="font-bold text-lg text-dark truncate">{headerText}</h2>
      </div>

      {/* Divider */}
      <div className="h-px bg-grey3light w-full" />

      {/* Content section with fixed constraints */}
      <div className="mt-4 flex-1 min-h-0">
        <p className="text-base text-dark line-clamp-5">{contentText}</p>
      </div>

      {/* Button - fixed position at bottom */}
      <Button
        label={buttonText}
        buttonType={ButtonType.PRIMARY}
        onClick={onButtonTap}
        className="w-full mt-4"
      />
    </div>
  );
}
